import { useTranslation } from "react-i18next";

import { LeadV2Status } from "../../../api/generated";
import { LeadRawStatus } from "../../RecentLeadStatus/types";

export const useRecentLeadsTranslatedContent = () => {
  const { t } = useTranslation();

  return {
    leadStatusMapping: new Map<string, string>([
      // LeadV2Status
      [LeadV2Status.Unknown, t("leadsPage_table_status_unknown")],
      [
        LeadV2Status.IncompleteProfile,
        t("leadsPage_table_status_incomplete_profile"),
      ],
      [
        LeadV2Status.CompletingProfile,
        t("leadsPage_table_status_completing_profile"),
      ],
      [
        LeadV2Status.ReviewingSuitability,
        t("leadsPage_table_status_review_suitability"),
      ],
      [
        LeadV2Status.IdentifyVerification,
        t("leadsPage_table_status_identify_verification"),
      ],
      [LeadV2Status.Approved, t("leadsPage_table_status_approved")],
      [
        LeadV2Status.VerifyingIdentity,
        t("leadsPage_table_status_verifying_identity"),
      ],
      //===== LeadRawStatus ======
      [
        LeadRawStatus.Demo,
        t("leadsPage_table_status_demo_label", {
          defaultValue: "Live account setup",
        }),
      ],
      [
        LeadRawStatus.Lead_1,
        t("leadsPage_table_status_lead_1_label", { defaultValue: "E&I" }),
      ],
      [
        LeadRawStatus.Lead_2,
        t("leadsPage_table_status_lead_2_label", {
          defaultValue: "Experience check",
        }),
      ],
      [
        LeadRawStatus.Lead_4,
        t("leadsPage_table_status_lead_4_label", {
          defaultValue: "Identity verification",
        }),
      ],
      [
        LeadRawStatus.Lead_5,
        t("leadsPage_table_status_lead_5_label", {
          defaultValue: "Under review",
        }),
      ],
      [
        LeadRawStatus.Unknown,
        t("leadsPage_table_status_unknown", { defaultValue: "Unknown" }),
      ],
      [
        LeadRawStatus.Approved,
        t("leadsPage_table_status_approved", { defaultValue: "Approved" }),
      ],
    ]),
    leadStatusTooltipLabelMapping: new Map<string, string>([
      [LeadRawStatus.Demo, t("leadsPage_table_status_demo_tooltip_label")],
      [LeadRawStatus.Lead_1, t("leadsPage_table_status_lead_1_tooltip_label")],
      [LeadRawStatus.Lead_2, t("leadsPage_table_status_lead_2_tooltip_label")],
      [LeadRawStatus.Lead_4, t("leadsPage_table_status_lead_4_tooltip_label")],
      [LeadRawStatus.Lead_5, t("leadsPage_table_status_lead_5_tooltip_label")],
      [LeadRawStatus.Unknown, t("leadsPage_table_status_unknown")],
      [LeadRawStatus.Approved, t("leadsPage_table_status_approved")],
    ]),
    descriptionStatusMapping: new Map<string, string>([
      [
        LeadV2Status.IncompleteProfile,
        t("leadsPage_table_status_incomplete_profile_description"),
      ],
      [
        LeadV2Status.CompletingProfile,
        t("leadsPage_table_status_completing_profile_description"),
      ],
      [
        LeadV2Status.ReviewingSuitability,
        t("leadsPage_table_status_review_suitability_description"),
      ],
      [
        LeadV2Status.IdentifyVerification,
        t("leadsPage_table_status_identify_verification_description"),
      ],
      [LeadV2Status.Approved, t("leadsPage_table_status_approved_description")],
      [
        LeadV2Status.VerifyingIdentity,
        t("leadsPage_table_status_verifying_identity_description"),
      ],
      [LeadV2Status.Unknown, t("leadsPage_table_status_unknown_description")],
      [LeadRawStatus.Demo, t("leadsPage_table_status_demo_description")],
      [LeadRawStatus.Lead_1, t("leadsPage_table_status_lead_1_description")],
      [LeadRawStatus.Lead_2, t("leadsPage_table_status_lead_2_description")],
      [LeadRawStatus.Lead_4, t("leadsPage_table_status_lead_4_description")],
      [LeadRawStatus.Lead_5, t("leadsPage_table_status_lead_5_description")],
      [LeadRawStatus.Unknown, t("leadsPage_table_status_unknown_description")],
    ]),
    stepMapping: new Map<string, string>([
      [LeadRawStatus.Demo, t("leadsPage_table_status_demo_step", "Step 1/5")],
      [
        LeadRawStatus.Lead_1,
        t("leadsPage_table_status_lead_1_step", "Step 2/5"),
      ],
      [
        LeadRawStatus.Lead_2,
        t("leadsPage_table_status_lead_2_step", "Step 3/5"),
      ],
      [
        LeadRawStatus.Lead_4,
        t("leadsPage_table_status_lead_4_step", "Step 4/5"),
      ],
      [
        LeadRawStatus.Lead_5,
        t("leadsPage_table_status_lead_5_step", "Step 5/5"),
      ],
    ]),
    goToLeads: t(
      "overviewForCompleteIBUserPage_recentLeads_go_to_leads_button_text",
    ),
    header: t("overviewForCompleteIBUserPage_recentLeads_header"),
    clientIdColumn: t("leadsPage_table_column_label_client_id"),
    nameColumn: t("leadsPage_table_column_label_name"),
    createdColumn: t("leadsPage_table_column_label_profile_created"),
    statusColumn: t("leadsPage_table_column_label_status"),
    noDataFound: t("overviewForCompleteIBUserPage_no_data_found_text"),
    onboardingStatusColumn: t("leadsPage_table_column_label_onboarding_status"),
    signupDateColumn: t("leadsPage_table_column_label_signup_date"),
    confirm: t("leadsPage_table_status_confirm_button"),
    approvedDescription2: t("leadsPage_table_status_approved_description2"),
  };
};
